// skeleton/app/src/app/sso-login/sso-login.component.ts

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../shared/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { NotificationService } from '../shared/services/notifications.service';
import { LogoutServive } from '../logout/logout.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { AuthService } from '../auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-sso-login',
  standalone: true,
  imports: [],
  templateUrl: './sso-login.component.html',
  styleUrl: './sso-login.component.scss'
})
export class SSOLoginComponent implements OnInit, OnDestroy {
  ssoToken: string = "";
  UserLoggedIn: boolean = false;
  constant: Constants = new Constants();
  routeSubScription: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private baseHttpService: BaseHttpService,
    private router: Router,
    private notificationService: NotificationService,
    private authService: AuthService,
    private logoutservice: LogoutServive,
    private globalsessionhandler: GlobalsessionhandlerService,
    private spinnerService: NgxSpinnerService,
    private tokenStorage: StorageService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      console.log('url', params); // Print the parameter to the console.
    });
  }

  async loadAccessPermission() {
    this.globalsessionhandler.clearSession();
    //await this.authorization.initializePermissions();
  }

  ngOnInit() {
    this.routeSubScription = this.activatedRoute.queryParams.subscribe(params => {
      this.ssoToken = params['param1'];
      if (this.ssoToken) {
        const chars: any = { 'a': 'c', 'b': 'a', 'c': 'b' };
        this.ssoToken = this.ssoToken.replace(/[abc]/g, (m: string) => chars[m]);

        // Store incoming SSO token consistently via StorageService
        this.tokenStorage.set("token", this.ssoToken);

        this.LoginAuth();
      }
    });
  }

  LoginAuth() {
    this.spinnerService.show();

    this.baseHttpService.get(this.constant.surveySSOUrl).subscribe(
      async (result) => {
        if (result != null) {
          // Keep existing helper calls (if other code depends on them)
          this.tokenStorage.saveToken(result.auth_token);
          this.tokenStorage.saveRefreshToken(result.refresh_token);
          this.tokenStorage.saveUser(result);

          // Ensure raw keys are also stored consistently
          this.tokenStorage.set("token", result.auth_token);
          this.tokenStorage.set("refresh_token", result.refresh_token);

          this.globalsessionhandler.clearSession();
          this.globalsessionhandler.emitloginSucessful(true);

          this.navigateToUserActivity();
          this.UserLoggedIn = true;
          this.logoutservice.changeMessage(this.UserLoggedIn);
        } else {
          this.notificationService.showError("Unable to access the Survey tool", "Access Issue");
          this.authService.removeToken();
          this.UserLoggedIn = false;
        }

        this.spinnerService.hide();
      },
      error => {
        if (error?.error === true) {
          this.notificationService.showError(
            "User account is logged due to invalid login attempts. Please try after 15 minutes.",
            "Login failed",
          );
        } else {
          this.notificationService.showError("Unable to access the Survey tool", "Access Issue");
        }
        this.spinnerService.hide();
      }
    );
  }

  Navigate() {
    this.router.navigate(['/', 'register']);
  }

  NavigateToForgetPwd() {
    this.router.navigate(['/', 'forgotpassword']);
  }

  navigateToUserActivity() {
    this.router.navigate(["/reports"]);
  }

  ngOnDestroy() {
    this.routeSubScription?.unsubscribe();
  }
}
